import React from "react";
import LatestCollection from "../components/LatestCollection";
import BestSeller from "../components/BestSeller";
import OurPolicy from "../components/OurPolicy";
import NewsletterBox from "../components/NewsletterBox";
import { Helmet } from "react-helmet";
import Carousel from "../components/Carousel";
import { assets } from "../assets/assets";

const Home = () => {
  return (
    <div>
      <Helmet>
        <title>Buy Premium Curtains Online | Sahla Curtain Center, Kadungathukundu</title>
        <meta name="description" content="Shop premium curtains, blinds, and window treatments at Sahla Curtain Center. Best quality, expert installation, and top customer satisfaction in Kadungathukundu since 2000." />
        <meta name="keywords" content="curtains, premium curtains, window treatments, blinds, curtain store, Kadungathukundu, curtain installation, Sahla Curtain Center, home decor, buy curtains online, best curtain shop India" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Sahla Curtain Center - Premium Curtains & Window Solutions" />
        <meta property="og:description" content="Shop premium curtains, blinds, and window solutions at Sahla Curtain Center. Trusted since 2000 in Kadungathukundu." />
        <meta property="og:image" content="https://sccstore.vercel.app/preview.jpg" />
        <meta property="og:url" content="https://sccstore.vercel.app" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Sahla Curtain Center" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Sahla Curtain Center - Premium Curtains & Window Solutions" />
        <meta name="twitter:description" content="Shop premium curtains, blinds, and window solutions at Sahla Curtain Center. Trusted since 2000 in Kadungathukundu." />
        <meta name="twitter:image" content="https://sccstore.vercel.app/preview.jpg" />
        <link rel="canonical" href="https://sccstore.vercel.app" />
        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "Store",
            "name": "Sahla Curtain Center",
            "image": "https://sccstore.vercel.app/preview.jpg",
            "@id": "https://sccstore.vercel.app",
            "url": "https://sccstore.vercel.app",
            "telephone": "+91 9895846494",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Mambara Rd, Kadungathukundu Town, Kalpakanchery",
              "addressLocality": "Kadungathukundu",
              "addressRegion": "Kerala",
              "postalCode": "676551",
              "addressCountry": "IN"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 10.9398206,
              "longitude": 75.9788539
            },
            "sameAs": [
              "https://www.facebook.com/people/Sahla-Curtain-Center/61565451845405/",
              "https://www.youtube.com/@Sahlacurtaincenter"
            ]
          }
        `}</script>
      </Helmet>
      <Carousel />
      <LatestCollection />
      <BestSeller />
      <OurPolicy />
      <NewsletterBox />
    </div>
  );
};

export default Home;
